import React from 'react';
import type { VariantProps } from '@gluestack-ui/nativewind-utils';

import { vstackStyle } from './styles';

import { toDomStyle } from '@/util/domStyle';
import { translateRnA11yProps, type RnAccessibilityProps } from '@/util/accessibilityProps';

type IVStackProps = React.ComponentProps<'div'> &
  VariantProps<typeof vstackStyle> &
  RnAccessibilityProps & {
    testID?: string;
  };

const VStack = React.forwardRef<React.ElementRef<'div'>, IVStackProps>(
  ({ className, space, reversed, testID, style, ...props }, ref) => {
    const { rest, aria } = translateRnA11yProps(props as Record<string, unknown>);

    return (
      <div
        className={vstackStyle({ space, reversed, class: className })}
        data-testid={testID}
        {...rest}
        {...aria}
        style={toDomStyle(style)}
        ref={ref}
      />
    );
  }
);

VStack.displayName = 'VStack';

export { VStack };
